import React, { ReactElement, useEffect } from 'react';
import { Breadcrumbs, homeBreadcrumb } from 'slovlex-idsk-react-components';
import Layout from './Layout';
import routes from '../routing/routes';
import GlobalErrors from '../module/GlobalErrors';
import PrispevokVestnikaCreate from '../module/PrispevokVestnikaCreateUpdate/PrispevokVestnikaCreate';
import SecuredPage from '../module/SecuredPage';
import UserRole from '../model/currentuser/UserRole';
import { useClientStatusContext } from '../context/ClientStatusContext';
import PageHeadingWithBackButton from '../module/PageHeadingWithBackButton';

const PrispevokVestnikaCreatePage = (): ReactElement => {
  const {
    status,
  } = useClientStatusContext();

  useEffect(() => {
    window.parent.postMessage({
      type: 'iframe-to-parent-set-title',
      title: 'Nový príspevok vestníka',
    }, '*');
  }, []);

  return (
    <Layout>
      <Breadcrumbs routeList={[
        homeBreadcrumb(process.env.REACT_APP_PORTAL_MAIN_URL),
        {
          to: routes.prispevokVestnika.list.to,
          heading: routes.prispevokVestnika.list.name,
        },
        {
          to: routes.prispevokVestnika.add.to,
          heading: routes.prispevokVestnika.add.name,
        },
      ]}
      />
      <GlobalErrors />
      <SecuredPage
        allowForRoles={[UserRole.REZORTNE_ZBIERKY_IMPORT, UserRole.REZORTNE_ZBIERKY_SPRAVCA]}
        requestStatus={status?.responseCode}
      >
        <>
          <PageHeadingWithBackButton
            headingCaption="Nový príspevok vestníka"
          />
          <PrispevokVestnikaCreate />
        </>
      </SecuredPage>
    </Layout>
  );
};

export default PrispevokVestnikaCreatePage;
